import { LoadingSpinner } from '@plato/ui-legacy/components/loading/loading-spinner';
import Text from '@plato/ui-legacy/components/ui/text';
import { useTranslation } from 'react-i18next';
import { api } from '../../../utils/api.ts';
import { CommentItem } from './comment-item.tsx';
import { NewComment } from './new-comment.tsx';

type CommentsThreadProps = { taskId: string } | { noteId: string };

export function CommentsThread(props: CommentsThreadProps) {
    const { t } = useTranslation('tasks');

    const { data: commentsData, isLoading } = api.platoUser.query.comments.getManyComments.useQuery(props, {
        refetchInterval: 5000,
    });

    const comments = commentsData || [];

    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-12">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-3">
            <Text color="neutral-950" weight="medium">
                {t('comments__section_title')}
            </Text>
            {comments.length > 0 && (
                <div className="flex flex-col gap-3">
                    {comments.map((comment) => (
                        <CommentItem key={comment.commentId} comment={comment} />
                    ))}
                </div>
            )}
            <NewComment {...props} />
        </div>
    );
}
